import { memo } from 'react'
import { Trans } from 'react-i18next'

import { faCheckCircle } from '@fortawesome/pro-duotone-svg-icons'
import customConfig from 'customConfig'
import { MESSAGE_TEXT } from '../../../constants/messages'
import { COLOR_SUCCESS } from '../../../constants/theme'
import AnimateRewards from '../../shared/animateRewards/AnimateRewards'
import Popup from '../../shared/popup/Popup'
import Text from '../../shared/text/Text'

const NftCodeSuccess = ({ reward, onAwesomeClick, t }) => {
  const isFutureReward = reward?.campaign?.deltaSeconds
  return (
    <Popup
      title={
        isFutureReward
          ? t('reward.future-reward-nft')
          : t(customConfig.nftReceivedTitle)
      }
      description={
        isFutureReward ? (
          <Trans
            i18nKey='reward.future-reward-success'
            values={{
              value: 1,
              name: reward?.campaign?.token?.name
            }}
          />
        ) : (
          t(MESSAGE_TEXT.NFT_SUCCESS_DESCRIPTION)
        )
      }
      icon={faCheckCircle}
      color={COLOR_SUCCESS}
      onFormSubmit={onAwesomeClick}
      submitLabel={t(
        isFutureReward ? 'common.awesome' : 'brand:nft.get-added-reward'
      )}
    >
      <>
        {isFutureReward && <Text label={t('reward.future-reward-desc-nft')} />}
        <AnimateRewards />
      </>
    </Popup>
  )
}

export default memo(NftCodeSuccess)
